import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import React from "react";

interface ThemeProviderProps<Theme> {
  theme: Partial<Theme> | ((outerTheme: Theme) => Theme);
  children?: React.ReactNode;
}

export default function ThemeProvider<Theme>(
  props: ThemeProviderProps<Theme>
): React.ReactElement {
  return <EmotionThemeProvider {...props} />;
}
